import React from "react";
import { useSnackbar } from "notistack";
import colorConfigs from "../../../configs/colorConfigs";
import { typo } from "../../../assets/fonts/font";

interface OrderNotificationsProps {
  orderSuccess: boolean;
  orderError: string | null;
  onCloseSuccess: () => void;
  onCloseError: () => void;
}

export const OrderNotifications = ({
  orderSuccess,
  orderError,
  onCloseSuccess,
  onCloseError
}: OrderNotificationsProps) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (orderSuccess) {
      const key = enqueueSnackbar("Order placed successfully! Redirecting to order details...", {
        variant: "success",
        autoHideDuration: 6000,
        onClose: onCloseSuccess,
        style: {
          backgroundColor: colorConfigs.primary,
          ...typo.bodyContent
        }
      });
      return () => closeSnackbar(key);
    }
  }, [orderSuccess, enqueueSnackbar, closeSnackbar, onCloseSuccess]);

  React.useEffect(() => {
    if (orderError) {
      const key = enqueueSnackbar(orderError, {
        variant: "error",
        autoHideDuration: 6000,
        onClose: onCloseError,
        style: {
          backgroundColor: colorConfigs.errorBg,
          ...typo.bodyContent
        }
      });
      return () => closeSnackbar(key);
    }
  }, [orderError, enqueueSnackbar, closeSnackbar, onCloseError]);

  return null;
};